import React from 'react';
import ManageItemForm from '../Forms/manage_item_form';
import { ManageDataPage } from './manageDataShared';

const COLUMNS = [
    { label: 'Name', field: 'Name' },
    { label: 'Category', field: 'Category' },
    { label: 'Height/Thickness', field: 'HeightOrThickness' },
    { label: 'Tally Name', field: 'TallyName' },
];

function Manage_item() {
    return (
        <ManageDataPage
            title="Manage Item"
            endpoint="get_manage_item_table"
            columns={COLUMNS}
            idKey="ItemID"
            FormComponent={ManageItemForm}
            searchPlaceholder="Search name, category, tally name..."
        />
    );
}

export default Manage_item;
